import apiCall from '../components/apiCall';
import {
  UPDATE_FEEDBACK,
  SET_ROUND,
} from './types';
import actions from '../actions';
const fetchFeedback = () => dispatch => {
  return apiCall(`/simulatiespel/feedback`)
    .then((feedback) => {
      dispatch({ type: UPDATE_FEEDBACK, payload: feedback });
    })
    .catch((err) => {
      console.warn(err.message);
    });
};

/**
 *
 * @param round
 * @return {Function}
 */
const setRound = (round) => (dispatch, getState) => {
  const { gameState } = getState();
  const currentRound = gameState.Rounds[round] || { id: 0 };

  // Fetch policy choices for this round
  dispatch(actions.policyChoice.updatePolicyOptions(currentRound.id));
  dispatch({ type: SET_ROUND, payload: round });
};

const updateRead = (feedbackId, read) => dispatch => {
  apiCall(`/simulatiespel/feedback/${feedbackId}/updateRead`, read, 'PUT');
};

export default {
  fetchFeedback,
  updateRead,
  setRound,
};



// WEBPACK FOOTER //
// ./src/actions/feedback.js